<template>
  <el-dialog title="原料供应商" :visible="isShow" width="85%" @close="cancel('showPlanDialog')">
    <div>
      <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code">
                  <el-select v-model="queryCondition.category3Code" clearable style="width:100%" placeholder="请选择">
                    <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ASL Group" prop="aslGroupName">
                  <el-input v-model="queryCondition.aslGroupName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ASL" prop="aslName">
                  <el-input v-model="queryCondition.aslName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Ownership" prop="ownership">
              <el-select v-model="queryCondition.ownership" clearable filterable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in ownershipOptions" :label="item.object" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="国内/国外" prop="domesticOrOverseas">
              <el-select v-model="queryCondition.domesticOrOverseas" clearable filterable placeholder="请选择" style="width:100%">
                <el-option :key="index" v-for="(item,index) in domesticOrOverseas" :label="item.object" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态" prop="aslStatus">
              <el-select v-model="queryCondition.aslStatus" clearable filterable placeholder="请选择" style="width:100%" disabled>
                <el-option :key="index" v-for="(item,index) in statusList" :label="item.object" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">重置</el-button>
        </el-row>
      </el-form>
      <div style="padding-bottom: 15px;"></div>
      <el-table :data="tableList" row-key="rmcProteinAslId" ref="tableList" border highlight-current-row max-height="420">
        <el-table-column align="center" width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.row.rmcProteinAslId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="category3Name" label="Category3" min-width="120"></el-table-column>
        <el-table-column prop="sponsorName" label="Sponsor" min-width="140"></el-table-column>
        <el-table-column prop="aslGroupName" label="ASL Group" min-width="140"></el-table-column>
        <el-table-column prop="aslName" label="ASL" min-width="140"></el-table-column>
        <el-table-column prop="ownership" label="Ownership" min-width="140"></el-table-column>
        <el-table-column prop="domesticOrOverseasView" label="国内/国外" min-width="140"></el-table-column>
        <el-table-column prop="countryRegion" label="国家" min-width="140"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
      <div class="foot-btn" style="padding-top: 10px;text-align: center">
        <el-button type="primary" @click="confirmMethod">{{ $t('common.confirm') }}</el-button>
        <el-button @click="cancel('showPlanDialog')">{{ $t('common.cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import aslApi from "@/api/rmcProtein/asl";

export default {
  extends: commonFunction,
  components: {
    IcSelect
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    createFun: {
      type: Function,
      default: function () {
      }
    }
  },
  data() {
    return {
      categoryList3: [],
      domesticOrOverseas: [],
      ownershipOptions: [],
      statusList: [],
      queryCondition: {
        category3Code: '',
        sponsorName: '',
        aslGroupName: "",
        aslName: "",
        ownership: '',
        domesticOrOverseas: "",
        aslStatus: 'Active',
        pageNum: 1,
        pageSize: 15
      },
      tableList: [],
      totalCount: 0,
      radioVal: null,
    };
  },
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          this.queryData();
        }
      }
    }
  },
  created() {
    this.getCategory3Lists();
  },
  mounted() {

  },
  methods: {
    getCategory3Lists() {
      aslApi.getCategory3(['rmc.RmcCategory3', 'rmc.RmcProteinAslOwnership', 'rmc.RmcDomesticOrOverseas', 'rmc.RmcProteinAslStatus']).then((res) => {
        if (res.code == 200) {
          this.categoryList3 = res.data['rmc.RmcCategory3'].filter((v) => {
            return v.cascadeKey == 'protein'
          })
          this.domesticOrOverseas = res.data['rmc.RmcDomesticOrOverseas']
          this.ownershipOptions = res.data['rmc.RmcProteinAslOwnership']
          this.statusList = res.data['rmc.RmcProteinAslStatus']
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      aslApi.getAslDataAll(this.queryCondition).then((res) => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    // 确认选中
    confirmMethod() {
      console.log(this.radioVal)
      if (!!this.radioVal) {
        const changeRow = this.tableList.filter(item => item.rmcProteinAslId === this.radioVal);
        this.createFun(changeRow[0]);
        this.radioVal = null
      } else {
        this.$message({
          type: "error",
          message: this.$t("common.pleaseSelectData")
        });
      }
    }
  }
};
</script>
